import { doGet, doPost } from "./common";
import { getsecret, secret } from "./crypt";

function getExcelSchema(params, callback) {
  const endpoint = `/files`;

  if (secret === undefined) {
    getsecret(() => {
      doGet(endpoint, params, callback, false);
    });
  } else {
    doGet(endpoint, params, callback, false);
  }
}

function saveExcelSchema(body, callback) {
  const endpoint = `/files`;

  if (secret === undefined) {
    getsecret(() => {
      doPost(endpoint, {}, body, callback, true);
    });
  } else {
    doPost(endpoint, {}, body, callback, true);
  }
}

export { getExcelSchema, saveExcelSchema };
